export default defineNuxtPlugin(() => {
  installDeviceSectionBack(useRouter())
})
